import { useMemo } from 'react';

import { generateQrMatrix, type QrGenerationResult } from '../domain/generator';
import type { ErrorCorrectionLevel } from '../domain/types';

/**
 * Generates the module matrix for the current content.
 *
 * Generation is synchronous and cheap, so this is a `useMemo` rather than the
 * previous effect-plus-four-state-variables arrangement. That removes the
 * window in which the component held a matrix from a *previous* input while
 * the new one was still being computed — the window in which a failed
 * generation used to leave a stale, downloadable QR code on screen.
 */
export function useQrMatrix(
  content: string,
  errorCorrectionLevel: ErrorCorrectionLevel,
): QrGenerationResult {
  return useMemo(
    () => generateQrMatrix(content, errorCorrectionLevel),
    [content, errorCorrectionLevel],
  );
}
